import '@voicemod1/harmony-ui/style.css';

import { createPinia } from 'pinia';
import { createApp } from 'vue';

import ModalManager from '@voicemod1/voicemod-modal-manager';

import App from './App.vue';
import { abTests } from './experiments';
import router from './router';
import { initSentry, logBuildInfo } from './utils';

import { i18n, loadLanguageAsync } from '@/i18n/i18n-setup';
import { mParticleMetric } from '@/metrics';

logBuildInfo();

abTests.init();
mParticleMetric.init();
void loadLanguageAsync();

const app = createApp(App)
	.use(router)
	.use(createPinia())
	.use(i18n)
	.use(ModalManager);

initSentry(app, router);

app.mount('#app');
